import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PaymentPopup from './PaymentPopup'
import PaymentPage from './PaymentPage';
import Welcome from '../../../components/assets/images/ibcImages/welcomecard.jpg';
import Money from '../../../components/assets/images/ibcImages/moneycard.jpg';
import Shop from '../../../components/assets/images/ibcImages/shopcard.jpg';
import Funding from '../../../components/assets/images/ibcImages/fundingcard.jpg';
import Done from '../../../components/assets/images/ibcImages/donecard.jpg';


const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: '0 auto',
    borderRadius: 15,
    overflow: 'hidden',
    marginTop: 30,
  },
  packageCardBg: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
  },
  eyebrow:{
    background: '#d1e9f8',
    marginBottom: 30,
    width: 'max-content',
    color: '#59b1e6',
    padding: '3px 10px',
    borderRadius: 25,
    fontSize: 12,
  },
  packageCardContent: {
    position: 'relative',
    minHeight:250,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  heading: {
    maxWidth: '70%',
    color: '#fff',
    fontWeight: 'bold',
  },
  details: {
    maxWidth: '70%',
    color: '#fff',
  },
  packagePrice:{
    fontWeight: 'bold',
    color: '#fff',
    fontSize: 24,
    marginTop: 4,
  },
  button: {
    alignSelf: 'flex-end',
  },
  plansWrapper: {
  display: 'flex',
  justifyContent: 'center',
  gap: 40,
  marginTop: 40,

  // 👇 MOBILE FIX
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    alignItems: 'center',
  },
},

planCard: {
  width: 420,
  borderRadius: 16,
  padding: 40,
  textAlign: 'center',
  background: '#fff',
  boxShadow: '0 12px 30px rgba(0,0,0,0.08)',

  // 👇 MOBILE FIX
  '@media (max-width: 768px)': {
    width: '90%',
    padding: 24,
  },
},


  paymentPanel: {
    maxWidth: 380,
    width: 380,
    flex: '0 0 380px',
    borderRadius: 15,
    background: '#fff',
    padding: 24,
    boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
  },

  paymentPanelWrapper: {
    display: 'flex',
    gap: 24,
    justifyContent: 'center',
    alignItems: 'stretch',
    flexWrap: 'nowrap',
    marginTop: 30,
  },
  paymentInner: {
    width: '100%',
    maxWidth: 360,
    margin: '0 auto',
  },
  planTitle: {
  fontWeight: 600,
  letterSpacing: 1,
  textTransform: 'uppercase',
  position: 'relative',
  paddingBottom: 14,
  marginBottom: 24,
  display: 'inline-block',

  '&::after': {
    content: '""',
    position: 'absolute',
    left: '50%',
    bottom: 0,
    transform: 'translateX(-50%)',
    width: 72,              // 🔴 SAME underline length for all
    height: 3,
    backgroundColor: '#DC281E',
    borderRadius: 2,
  },
},


});
function getSteps() {
  return ['Step 1', 'Step 2', 'Step 3', 'Choose Plan'];
}

export default function PackageCard(props) {
  const classes = useStyles();

  const { packageDetails, userDetails } = props;
  const [payment, setPayment] = React.useState(false);
  const [selectedPlan, setSelectedPlan] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const getStepContent = (step) => {
    switch (step) {
        case 0:
            return (<Card className={classes.root} component="div">
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={Welcome}
                  alt="Package image"
                  className={classes.packageCardBg}
                />
                <CardContent className={classes.packageCardContent}>
                  <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                  Welcome <br></br>Let’s get a membership.
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p" className={classes.details}>
                    {packageDetails?.details || 'Become a member to the club of entrepreneurs and investors'}
                  </Typography>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                  >
                      Continue
                  </Button>
                </CardContent>
              </CardActionArea>
              
            </Card>);
        case 1:
            return (<Card className={classes.root} component="div">
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={Money}
                  alt="Package image"
                  className={classes.packageCardBg}
                />
                <CardContent className={classes.packageCardContent}>
                  <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                  Grow your business with us
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p" className={classes.details}>
                  We aim to provide business opportunities to existing and upcoming businesses.
                  </Typography>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                  >
                      Continue
                  </Button>
                </CardContent>
              </CardActionArea>
              
            </Card>);
        case 2:
            return (<Card className={classes.root} component="div">
              <CardActionArea>
                <CardMedia
                  component="img"
                  image={Shop}
                  alt="Package image"
                  className={classes.packageCardBg}
                />
                <CardContent className={classes.packageCardContent}>
                  {/* <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                    Get funding for your business
                  </Typography> */}
                  <Typography gutterBottom variant="h5" component="h2" className={classes.heading}>
                    {packageDetails?.heading || 'Get funding for your business'}
                  </Typography>
                  {/* <Typography className={classes.packagePrice}>
                    {packageDetails?.price && (
                      <Typography className={classes.packagePrice}>
                        {packageDetails.price}
                      </Typography>
                    )}
                  </Typography> */}

                  <Typography variant="body2" color="textSecondary" component="p" className={classes.details}>
                    We will help to find the best investment option for your business.
                  </Typography>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                  >
                      Continue
                  </Button>
                </CardContent>
              </CardActionArea>
            </Card>);
        case 3:
  return (
    <>
      {/* ✅ HEADING — THIS WAS MISSING */}
      <Typography
        variant="h4"
        style={{
          textAlign: 'center',
          fontWeight: 600,
          marginTop: 40,
          marginBottom: 40,
        }}
      >
        Choose your LeaperX membership plan
      </Typography>

      {/* ✅ CARDS */}
      <div className={classes.plansWrapper}>
        {[
          {
            id: 'STANDARD',
            heading: 'STANDARD',
            price: '₹ 15,000/-',
            description: 'For growing businesses getting started, Become a member of the club to grow your business to next level, start registration after the payment',
            amount: 15000,
          },
          {
            id: 'VIP',
            heading: 'VIP',
            price: '₹ 25,000/-',
            description: 'For businesses that want priority and visibility, Become a member of the club to grow your business to next level, start registration after the payment',
            amount: 25000,
          },
        ].map((plan) => (
          <Card key={plan.id} className={classes.planCard}>
            <Typography variant="h6" className={classes.planTitle}>
  {plan.heading}
</Typography>

{/* ✅ DESCRIPTION */}
<Typography
  style={{
    fontSize: 15,
    color: '#666',
    marginBottom: 20,
    lineHeight: 1.5,
  }}
>
  {plan.description}
</Typography>

<Typography
  style={{
    fontSize: 28,
    fontWeight: 700,
    margin: '24px 0',
  }}
>
  {plan.price}
</Typography>


            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                setSelectedPlan(plan);
                setPayment(true);
              }}
            >
              Continue
            </Button>
          </Card>
        ))}
      </div>
    </>
  );
        default:
            return 'Unknown step';
    }
}


  return (
    <div>
      <div>
          <div>{getStepContent(activeStep)}</div>
      </div>
      {selectedPlan && (
        <PaymentPopup
          defaultState={payment}
          componentToPassDown={
            <PaymentPage
              userDetails={userDetails}
              packageDetails={selectedPlan}
              handleClose={() => {
                setPayment(false);
                setSelectedPlan(null);
              }}
            />
          }
          handleClose={() => {
            setPayment(false);
            setSelectedPlan(null);
          }}
        />
      )}

    </div>
  );
}
